import {endOfMonth, endOfQuarter, endOfYear, formatISO, getQuarter, getYear, parseISO} from "date-fns";

import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {RcnPriceStatsSeriesPoint} from "../types/RcnPriceStatsSeriesPoint";
import {formatRcnPeriodMonth, formatRcnPeriodWithPreposition} from "./format_rcn_period";

const QUARTER_ROMAN_NUMERALS = ["I", "II", "III", "IV"];
const QUARTER_LABEL_PATTERN = /^(\d{4})-Q([1-4])$/;
const MONTH_LABEL_PATTERN = /^(\d{4})-(\d{2})$/;
const YEAR_LABEL_PATTERN = /^\d{4}$/;

const monthNameFormatter = new Intl.DateTimeFormat("pl-PL", {month: "long"});

export const formatRcnPeriodLabel = (periodLabel: string): string => {
    const quarterMatch = QUARTER_LABEL_PATTERN.exec(periodLabel);

    if (quarterMatch) {
        return `${QUARTER_ROMAN_NUMERALS[Number(quarterMatch[2]) - 1]} kw. ${quarterMatch[1]}`;
    }

    const monthMatch = MONTH_LABEL_PATTERN.exec(periodLabel);

    if (monthMatch) {
        const monthName = monthNameFormatter.format(new Date(Number(monthMatch[1]), Number(monthMatch[2]) - 1, 1));

        return `${monthName} ${monthMatch[1]}`;
    }

    return periodLabel;
};

/** The grain a period_label belongs to: "2026-06" month, "2025-Q2" quarter, "2025" year; null when unknown. */
export const getRcnPeriodGrain = (periodLabel: string): RcnPriceStatsGrain | null => {
    if (MONTH_LABEL_PATTERN.test(periodLabel)) {
        return "month";
    }

    if (QUARTER_LABEL_PATTERN.test(periodLabel)) {
        return "quarter";
    }

    return YEAR_LABEL_PATTERN.test(periodLabel) ? "year" : null;
};

type RcnPeriod = Pick<RcnPriceStatsSeriesPoint, "period_start" | "period_label">;

/**
 * Names the period of an address point in whatever grain it was published: "czerwiec 2026", "II kw. 2025",
 * "2025 r.". A label of no known shape is read as a month, which is what the address page asked for first.
 */
export const formatRcnPointPeriod = (period: RcnPeriod): string => {
    switch (getRcnPeriodGrain(period.period_label)) {
        case "quarter":
            return formatRcnPeriodLabel(period.period_label);
        case "year":
            return `${period.period_label} r.`;
        default:
            return formatRcnPeriodMonth(period.period_start);
    }
};

// Three-letter Polish month abbreviations, as on calendars and in tables ("paź", not "paźdz.").
const SHORT_MONTH_NAMES = ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"];

/**
 * The short form of formatRcnPointPeriod, for a caption next to a price: "lip 2025", "III kw. 2024", "2025 r.".
 * A label of no known shape is read as a month, like formatRcnPointPeriod does.
 */
export const formatRcnPointPeriodShort = (period: RcnPeriod): string => {
    switch (getRcnPeriodGrain(period.period_label)) {
        case "quarter":
        case "year":
            return formatRcnPointPeriod(period);
        default: {
            const [year, month] = period.period_start.split("-");

            return `${SHORT_MONTH_NAMES[Number(month) - 1] ?? month} ${year}`;
        }
    }
};

// "z czerwca 2026" / "ze stycznia 2026" / "z II kw. 2025" / "z 2025 r." - for "dane …", "Wszystkie wartości pochodzą …".
export const formatRcnPointPeriodWithPreposition = (period: RcnPeriod): string => {
    const grain = getRcnPeriodGrain(period.period_label);

    return grain === "quarter" || grain === "year" ? `z ${formatRcnPointPeriod(period)}` : formatRcnPeriodWithPreposition(period.period_start);
};

// A plain "2026-01-15" date has no RCN period_label of its own (that only comes back from the API) -
// this derives the quarter one would belong to, so a date from a monthly series can share formatRcnPeriodLabel
// with the RCN quarterly series instead of a separate month-only formatter.
export const formatQuarterLabelForDate = (dateString: string): string => {
    const date = parseISO(dateString);

    return formatRcnPeriodLabel(`${getYear(date)}-Q${getQuarter(date)}`);
};

export const getRcnPeriodEndDate = (periodStart: string, periodLabel: string): string | null => {
    const start = parseISO(periodStart);

    if (Number.isNaN(start.getTime())) {
        return null;
    }

    const end = QUARTER_LABEL_PATTERN.test(periodLabel)
        ? endOfQuarter(start)
        : MONTH_LABEL_PATTERN.test(periodLabel)
          ? endOfMonth(start)
          : YEAR_LABEL_PATTERN.test(periodLabel)
            ? endOfYear(start)
            : null;

    return end ? formatISO(end, {representation: "date"}) : null;
};

/**
 * The period of a point as an ISO 8601 interval, for schema.org's temporalCoverage: "2022-07-01/2022-09-30" -
 * a "2022-Q3" period_label is no ISO date. Falls back to the label when the period cannot be dated.
 */
export const getRcnPointTemporalCoverage = (period: RcnPeriod): string => {
    const periodEnd = getRcnPeriodEndDate(period.period_start, period.period_label);

    return periodEnd ? `${period.period_start}/${periodEnd}` : period.period_label;
};
import {endOfMonth, endOfQuarter, endOfYear, formatISO, getQuarter, getYear, parseISO} from "date-fns";

import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {RcnPriceStatsSeriesPoint} from "../types/RcnPriceStatsSeriesPoint";
import {formatRcnPeriodMonth, formatRcnPeriodWithPreposition} from "./format_rcn_period";

const QUARTER_ROMAN_NUMERALS = ["I", "II", "III", "IV"];
const QUARTER_LABEL_PATTERN = /^(\d{4})-Q([1-4])$/;
const MONTH_LABEL_PATTERN = /^(\d{4})-(\d{2})$/;
const YEAR_LABEL_PATTERN = /^\d{4}$/;

const monthNameFormatter = new Intl.DateTimeFormat("pl-PL", {month: "long"});

export const formatRcnPeriodLabel = (periodLabel: string): string => {
    const quarterMatch = QUARTER_LABEL_PATTERN.exec(periodLabel);

    if (quarterMatch) {
        return `${QUARTER_ROMAN_NUMERALS[Number(quarterMatch[2]) - 1]} kw. ${quarterMatch[1]}`;
    }

    const monthMatch = MONTH_LABEL_PATTERN.exec(periodLabel);

    if (monthMatch) {
        const monthName = monthNameFormatter.format(new Date(Number(monthMatch[1]), Number(monthMatch[2]) - 1, 1));

        return `${monthName} ${monthMatch[1]}`;
    }

    return periodLabel;
};

/** The grain a period_label belongs to: "2026-06" month, "2025-Q2" quarter, "2025" year; null when unknown. */
export const getRcnPeriodGrain = (periodLabel: string): RcnPriceStatsGrain | null => {
    if (MONTH_LABEL_PATTERN.test(periodLabel)) {
        return "month";
    }

    if (QUARTER_LABEL_PATTERN.test(periodLabel)) {
        return "quarter";
    }

    return YEAR_LABEL_PATTERN.test(periodLabel) ? "year" : null;
};

type RcnPeriod = Pick<RcnPriceStatsSeriesPoint, "period_start" | "period_label">;

/**
 * Names the period of an address point in whatever grain it was published: "czerwiec 2026", "II kw. 2025",
 * "2025 r.". A label of no known shape is read as a month, which is what the address page asked for first.
 */
export const formatRcnPointPeriod = (period: RcnPeriod): string => {
    switch (getRcnPeriodGrain(period.period_label)) {
        case "quarter":
            return formatRcnPeriodLabel(period.period_label);
        case "year":
            return `${period.period_label} r.`;
        default:
            return formatRcnPeriodMonth(period.period_start);
    }
};

// Three-letter Polish month abbreviations, as on calendars and in tables ("paź", not "paźdz.").
const SHORT_MONTH_NAMES = ["sty", "lut", "mar", "kwi", "maj", "cze", "lip", "sie", "wrz", "paź", "lis", "gru"];

/**
 * The short form of formatRcnPointPeriod, for a caption next to a price: "lip 2025", "III kw. 2024", "2025 r.".
 * A label of no known shape is read as a month, like formatRcnPointPeriod does.
 */
export const formatRcnPointPeriodShort = (period: RcnPeriod): string => {
    switch (getRcnPeriodGrain(period.period_label)) {
        case "quarter":
        case "year":
            return formatRcnPointPeriod(period);
        default: {
            const [year, month] = period.period_start.split("-");

            return `${SHORT_MONTH_NAMES[Number(month) - 1] ?? month} ${year}`;
        }
    }
};

// "z czerwca 2026" / "ze stycznia 2026" / "z II kw. 2025" / "z 2025 r." - for "dane …", "Wszystkie wartości pochodzą …".
export const formatRcnPointPeriodWithPreposition = (period: RcnPeriod): string => {
    const grain = getRcnPeriodGrain(period.period_label);

    return grain === "quarter" || grain === "year" ? `z ${formatRcnPointPeriod(period)}` : formatRcnPeriodWithPreposition(period.period_start);
};

// A plain "2026-01-15" date has no RCN period_label of its own (that only comes back from the API) -
// this derives the quarter one would belong to, so a date from a monthly series can share formatRcnPeriodLabel
// with the RCN quarterly series instead of a separate month-only formatter.
export const formatQuarterLabelForDate = (dateString: string): string => {
    const date = parseISO(dateString);

    return formatRcnPeriodLabel(`${getYear(date)}-Q${getQuarter(date)}`);
};

export const getRcnPeriodEndDate = (periodStart: string, periodLabel: string): string | null => {
    const start = parseISO(periodStart);

    if (Number.isNaN(start.getTime())) {
        return null;
    }

    const end = QUARTER_LABEL_PATTERN.test(periodLabel)
        ? endOfQuarter(start)
        : MONTH_LABEL_PATTERN.test(periodLabel)
          ? endOfMonth(start)
          : YEAR_LABEL_PATTERN.test(periodLabel)
            ? endOfYear(start)
            : null;

    return end ? formatISO(end, {representation: "date"}) : null;
};

/**
 * The period of a point as an ISO 8601 interval, for schema.org's temporalCoverage: "2022-07-01/2022-09-30" -
 * a "2022-Q3" period_label is no ISO date. Falls back to the label when the period cannot be dated.
 */
export const getRcnPointTemporalCoverage = (period: RcnPeriod): string => {
    const periodEnd = getRcnPeriodEndDate(period.period_start, period.period_label);

    return periodEnd ? `${period.period_start}/${periodEnd}` : period.period_label;
};
